import React from "react";

const Header = () => {
  return (
    <header className="h-16 bg-white shadow flex items-center px-4">
      <h1 className="text-lg font-semibold text-gray-800">Dashboard</h1>
    </header>
  );
};

export default Header;
